/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { MaterialReactTable, MRT_ColumnDef, useMaterialReactTable, } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { tableStripedRowDark, tableStripedRowLight, tableHeaderGray } from "../../../../../../../constants/colors";
import {stringToDateToLocaleString} from "../../../../../../../helpers/helpers";
import {ArgosTableSimple} from "../../../../../../components/Table/ArgosTableSimple";
interface IErrorsRowsData {
    errorType: string,
    errorMessage: string,
    stackTrace: string,
    subRows?: IErrorsRowsData[]
    date?: string
}
const ExecutionErrorsVisualizer = (props: any) => {
 
    const errors = props.errors ?? {}
    const [rowsData, setRowsData] = useState<IErrorsRowsData[]>([]);

    useEffect(() => {
        mapBackendErrorsToRowsFormat();
    }, [props])

    const errorsColumns: MRT_ColumnDef<IErrorsRowsData>[] = [
        {
            accessorFn: (row: IErrorsRowsData) => row?.subRows ? row.errorType ?? '' : "",
            id: 'errorType',
            header: 'Error Type',
            size: 280, //default size is usually 180
        },
        {
            accessorFn: (row: IErrorsRowsData) => row?.subRows ? "" : row.errorMessage ?? '',
            id: 'errorMessage',
            header: 'Error Message',
            size: 450, //default size is usually 180
        },
        {
            accessorFn: (row: IErrorsRowsData) => row?.subRows ? "" : row.stackTrace ?? '',
            id: 'stackTrace',
            header: 'Stack Trace',
            size: 520, //default size is usually 180
        },
        {
            accessorKey: 'date',
            id: 'date',
            header: 'Date',
            size: 180, //default size is usually 180
        }
    ]


    const mapBackendErrorsToRowsFormat = () => {
        let _locaRows: IErrorsRowsData[] = [];
        let date = errors?.date
        if (date) {
            date = stringToDateToLocaleString(date)
        }
        Object.keys(errors)?.forEach((errorType: string) => {
            if (errorType === 'date') {
                return
            }
            let subRows: IErrorsRowsData[] = []
            if (errorType !== 'date') {
                subRows = [{
                    errorType: "",
                    errorMessage: errors[errorType]?.message,
                    stackTrace: errors[errorType]?.stackTrace,
                }]
            }
            let row: IErrorsRowsData = {
                "errorType": errorType,
                "errorMessage": "",
                "stackTrace": "",
                "subRows": subRows,
                "date": date
            }
            _locaRows.push(row)
        })
        setRowsData(_locaRows)
    }
    return (
      <div style={{overflow: 'auto', height:'100%'}}>
        <ArgosTableSimple 
            columns={errorsColumns}
            data={rowsData}
            enableExpanding
            enableBottomToolbar={true}
            enablePagination={true}
            initialState={{ expanded:true}}
            muiTableContainerProps={{ sx: { maxHeight: 700} }}
            muiExpandButtonProps={({ row }) => ({
                // Show expand button only when row has sub-elements
                sx: {
                    display: row.subRows?.length ? 'flex' : 'none'
                }
            })}
        />
      </div>
    )
}
export default ExecutionErrorsVisualizer;